<template>
  <view class="journey-container">
    <view wx:show="{{type === 'single'}}" class="single-city">
      <view
        class="single-city-left"
        wx:class="{{ {'move-r':isExchange, placeholder:!fromCitysName} }}"
        bindtap="cityTapHandler('from')"
      ><view class="max-ellipsis">{{fromCitysName}}</view></view>
      <view
        class="single-city-right"
        wx:class="{{ {'move-l':isExchange, placeholder:!toCitysName} }}"
        bindtap="cityTapHandler('to')"
      ><view class="max-ellipsis">{{toCitysName}}</view></view>
      <view
        class="change-btn"
        bindtap="exchange"
      >
        <image
          class="change-btn-wrapper"
          wx:class="{{isExchange ? 'rotate' : ''}}"
          mode="widthFix"
          src="{{exchangeWrapperIcon}}"
        />
        <image
          wx:if="{{exchangeIcon}}"
          class="change-btn-icon"
          mode="widthFix"
          src="{{exchangeIcon}}"
        />
      </view>
    </view>
    <view wx:show="{{type === 'mutiple'}}" class="mutiple-city">
      <view class="list-style">
        <view wx:for="{{[1,2]}}" class="point"></view>
      </view>
      <view class="citys">
        <view class="placeholder">
          <view
            class="mutiple-city-top"
             wx:class="{{ {'move-b':isExchange} }}"
            bindtap="cityTapHandler('from')"
          >
            <view
              class="max-ellipsis"
            >{{fromCitysName}}<text wx:show="{{fromCitys.length <= 1}}" class="tip">可多选</text></view>
          </view>
          <view
            class="mutiple-city-bottom"
             wx:class="{{ {'move-t':isExchange} }}"
            bindtap="cityTapHandler('to')"
          >
            <view
              class="max-ellipsis"
            >{{toCitysName}}<text wx:show="{{toCitys.length <= 1}}" class="tip">可多选</text></view>
          </view>
        </view>
      </view>
      <view bindtap="exchange" class="change-btn">
        <image src="{{changeIcon}}" mode="widthFix" class="change-icon"></image>
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import { debounce } from '@/utils'

  createComponent({
    properties: {
      type: {
        type: String,
        value: 'single', // single mutiple
      },
      fromCitys: {
        type: Array,
        value: () => ([])
      },
      toCitys: {
        type: Array,
        value: () => ([])
      },
      exchangeIcon: {
        type: String,
        value: ''
      }
    },
    data: {
      exchangeWrapperIcon: 'https://ut-static.udache.com/webx/sfc/_UzT6gnx4ASMGRvhOywRc.png',
      changeIcon: 'https://ut-static.udache.com/webx/sfc/lTS4DXNy8YBMPAuUmGAcn.png',
      isExchange: false,
    },
    computed: {
      fromCitysName() {
        return this.type === 'single'
          ? this.fromCitys[0].name || this.fromCitys[0].city_name
          : this.fromCitys.reduce((a,b) => {
            return a ? `${a}、${b.city_name}` : b.city_name
          }, '')
      },
      toCitysName() {
        return this.type === 'single'
          ? this.toCitys[0].name || this.toCitys[0].city_name
          : this.toCitys.reduce((a,b) => {
            return a ? `${a}、${b.city_name}` : b.city_name
          }, '')
      },
    },
    methods: {
      cityTapHandler(type) {
        this.triggerEvent('cityTap', type)
      },
      exchange: debounce(function() {
        this.isExchange = true
        setTimeout(() => {
          this.triggerEvent('exchange')
          this.$nextTick(() => {
            this.isExchange = false
          })
        }, 300)
      }, 300, true)
    }
  })
</script>

<style lang='stylus' scoped>
@keyframes Rotate
  0%
    transform rotate(0deg)
  100%
    transform rotate(180deg)

.journey-container
  .single-city
    box-sizing border-box
    height 54px
    border-bottom 0.5px solid #EEEEEE
    position relative
    .change-btn
      @extend .expand-click
      position absolute
      left 50%
      top 50%
      transform translateX(-50%) translateY(-50%)
      width 24px
      height 24px
      &-wrapper
        width 100%
        &.rotate
          animation Rotate .3s linear
      &-icon
        width 100%
        position absolute
        left 50%
        top 50%
        transform translateX(-50%) translateY(-50%)
    &-left, &-right
      @extend .flex-center
      position absolute
      height 100%
      white-space nowrap
      color #333
      font-size 20px
      font-weight 500
      font-family 'PingFangSC-Medium'
      &.placeholder
        width 100px
      .max-ellipsis
        max-width 150px
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
    &-right
      text-align right 
    .move-l, .move-r
      transition all .3s
    &-left, &-right.move-l
      left 0
      transform translateX(0)
    &-right, &-left.move-r
        left 100%
        transform translateX(-100%)
  .mutiple-city
    box-sizing border-box
    height 114px
    @extend .flex-center
    .list-style
      width 28px
      flex none
      display flex
      flex-direction column
      height 100%
      .point
        height 50%
        width 100%
        @extend .flex-center
        &::after
          content ''
          display block
          width 8px
          height 8px
          border-radius 50%
          background #06B87C
          margin-left 3px
        &:last-child::after
          background #FF6400
    .citys
      flex 1
      height 100%
      overflow hidden
      border-bottom 0.5px solid #EEEEEE
      .placeholder
        width 100%
        height 50%
        box-sizing border-box
        border-bottom 0.5px solid #EEEEEE
        position relative
        .mutiple-city-top, .mutiple-city-bottom
          width 100%
          min-height 20px
          position absolute
          transform translateY(-50%)
          color #333
          font-size 20px
          font-weight 500
          font-family 'PingFangSC-Medium'
          .max-ellipsis
            width 100%
            white-space nowrap
            overflow hidden
            text-overflow ellipsis
            .tip
              font-size 12px
              color #999
              font-family 'PingFangSC'
              font-weight 400
              margin-left 8px
              white-space inherit
        .move-t, .move-b
          transition all .3s
        .mutiple-city-top
          top 50%
          &.move-b
            top 150%
        .mutiple-city-bottom
          top 150%
          &.move-t
            top 50%
    .change-btn
      height 100%
      width 42px
      flex none
      border-bottom 1px solid #EEEEEE
      @extend .flex-center
      justify-content flex-end
      .change-icon
        width 24px
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
    }
  }
</script>
